(function(){
  'use strict';
  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(reduce)return;

  var colors=['#ef4444','#f28c28','#f2c300','#73b70b','#18a9c9','#4361ee','#7b2cbf','#ff4fa3'];
  var svg='<svg viewBox="0 0 40 40" aria-hidden="true" focusable="false"><defs><radialGradient id="wiTapGlow" cx="34%" cy="27%" r="70%"><stop offset="0" stop-color="#ffb14a"/><stop offset=".58" stop-color="#f47a28"/><stop offset="1" stop-color="#d94b22"/></radialGradient></defs><path d="M9.2 16.2C10.9 10.4 16.1 7.7 20 7.7s9.1 2.7 10.8 8.5c2.2 7.6-2.4 16.3-10.8 16.3S7 23.8 9.2 16.2z" fill="url(#wiTapGlow)" stroke="#b93b22" stroke-width="1.15"/><ellipse cx="15.4" cy="15.2" rx="3.3" ry="5.5" fill="#ffd27b" opacity=".34" transform="rotate(24 15.4 15.2)"/><path d="M20 10.1c-2.4-4.9-6.5-5.6-8.6-3.7 3.5.1 5 1.8 5.9 4.3-3-2-6.1-1.4-7.4.7 3.8-.8 6.2.5 8 2.3.5.5 1.5.5 2 0 1.8-1.8 4.2-3.1 8-2.3-1.3-2.1-4.4-2.7-7.4-.7.9-2.5 2.4-4.2 5.9-4.3-2.1-1.9-6.2-1.2-8.6 3.7z" fill="#4f8b3a" stroke="#356b2b" stroke-width=".8"/></svg>';

  function fruit(x,y){
    var el=document.createElement('span');
    el.className='wi-persimmon-tap';
    el.innerHTML=svg;
    el.style.left=x+'px';
    el.style.top=y+'px';
    document.body.appendChild(el);
    return el;
  }
  function spark(x,y,index,wide){
    var el=document.createElement('i');
    var angle=(index/colors.length)*Math.PI*2+(Math.random()*.3);
    var distance=(wide?20:9)+Math.random()*(wide?18:9);
    el.className='wi-persimmon-spark';
    el.style.left=(x-3)+'px';
    el.style.top=(y-3)+'px';
    el.style.background=colors[index%colors.length];
    el.style.color=colors[index%colors.length];
    el.style.setProperty('--wi-x',(Math.cos(angle)*distance)+'px');
    el.style.setProperty('--wi-y',(Math.sin(angle)*distance)+'px');
    document.body.appendChild(el);
    window.setTimeout(function(){el.remove();},620);
  }

  var fine=window.matchMedia&&window.matchMedia('(pointer: fine)').matches;
  if(fine){
    document.documentElement.classList.add('wi-persimmon-ready');
    var lastX=-100,lastY=-100,lastTrail=0,colorIndex=0;
    document.addEventListener('mousemove',function(e){
      var now=Date.now();
      var distance=Math.abs(e.clientX-lastX)+Math.abs(e.clientY-lastY);
      if(now-lastTrail>68&&distance>12){
        spark(e.clientX,e.clientY,colorIndex++,false);
        lastTrail=now;lastX=e.clientX;lastY=e.clientY;
      }
    },{passive:true});
  }


  var rainbowScroll=document.createElement('span');
  rainbowScroll.className='wi-rainbow-scroll';
  rainbowScroll.setAttribute('aria-hidden','true');
  document.body.appendChild(rainbowScroll);
  function positionRainbowScroll(){
    var max=Math.max(1,document.documentElement.scrollHeight-window.innerHeight);
    var ratio=Math.max(0,Math.min(1,window.scrollY/max));
    var travel=Math.max(0,window.innerHeight-72);
    rainbowScroll.style.setProperty('--wi-scroll-y',(ratio*travel)+'px');
  }
  positionRainbowScroll();
  var rainbowDragging=false;
  function dragRainbowScroll(e){
    if(!rainbowDragging)return;
    e.preventDefault();
    var travel=Math.max(1,window.innerHeight-72);
    var ratio=Math.max(0,Math.min(1,(e.clientY-36)/travel));
    var max=Math.max(1,document.documentElement.scrollHeight-window.innerHeight);
    window.scrollTo(0,ratio*max);
  }
  rainbowScroll.addEventListener('pointerdown',function(e){
    rainbowDragging=true;
    rainbowScroll.setPointerCapture(e.pointerId);
    dragRainbowScroll(e);
    e.stopPropagation();
  });
  rainbowScroll.addEventListener('pointermove',dragRainbowScroll);
  rainbowScroll.addEventListener('pointerup',function(e){
    rainbowDragging=false;
    if(rainbowScroll.hasPointerCapture(e.pointerId))rainbowScroll.releasePointerCapture(e.pointerId);
  });
  rainbowScroll.addEventListener('pointercancel',function(){rainbowDragging=false});
  window.addEventListener('resize',positionRainbowScroll,{passive:true});
  window.addEventListener('scroll',positionRainbowScroll,{passive:true});

  var scrollStarLast=0,scrollStarIndex=0;
  function makeScrollStar(){
    var now=Date.now();
    if(now-scrollStarLast<85)return;
    scrollStarLast=now;
    var max=Math.max(1,document.documentElement.scrollHeight-window.innerHeight);
    var ratio=Math.max(0,Math.min(1,window.scrollY/max));
    var star=document.createElement('i');
    star.className='wi-scroll-star';
    star.textContent='★';
    star.style.top=(18+ratio*Math.max(40,window.innerHeight-70))+'px';
    star.style.setProperty('--wi-star-color',colors[scrollStarIndex%colors.length]);
    star.style.setProperty('--wi-star-x',(-18-Math.random()*28)+'px');
    star.style.setProperty('--wi-star-y',(-12+Math.random()*24)+'px');
    scrollStarIndex++;
    document.body.appendChild(star);
    window.setTimeout(function(){star.remove();},760);
  }
  window.addEventListener('scroll',makeScrollStar,{passive:true});

  document.addEventListener('pointerdown',function(e){
    if(e.pointerType==='mouse')return;
    var pop=fruit(e.clientX,e.clientY);
    for(var i=0;i<colors.length;i++)spark(e.clientX,e.clientY,i,true);
    window.setTimeout(function(){pop.remove();},780);
  },{passive:true});
})();